import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import * as Actions from '../actions/testResult';
import { ITestResultState } from '../reducers/testResult';
import i18n from '../resources/i18n';

export interface ITestResultSimpleProps extends ITestResultState {
	classes: {
		resultRight: string;
		resultWrong: string;
		root: string;
		titleFailed: string;
		titlePassed: string;
	};
}

/**
 * テスト結果シンプル形式
 * @param props
 */
const TestResultSimple: React.FC<ITestResultSimpleProps> = props => {
	const {
		classes,
		score,
		scoreMessage,
		groups,
		questionGroupDisplay,
	} = props;

	const title = `${score}${i18n.t('TestResultSimple_0001')}  ${i18n.t(
		scoreMessage,
		{ ns: 'force' }
	)}`;
	const titleClass = props.passFlg
		? classes.titlePassed
		: classes.titleFailed;

	return (
		<div className={classes.root}>
			<Typography variant="h6" className={titleClass}>
				{title}
			</Typography>
			<List>
				{groups.map(group => {
					return group.questions.map((question, i) => {
						const itemTitle =
							questionGroupDisplay === true
								? `${group.groupTitle} ${
										question.questionNo
								  } :  `
								: `${question.questionNo} :  `;

						const resultClass =
							question.answerResultType ===
							Actions.AnswerResultTypes.RIGHT
								? classes.resultRight
								: classes.resultWrong;
						const m = /^([^\s\d]+)(\d+)\/(\d+)([^\s\d]+)$/.exec(
							question.answerResultMessage || ''
						);
						const answerResultMessage = m
							? i18n.t(m[1], { ns: 'force' }) +
							  m[2] +
							  '/' +
							  m[3] +
							  i18n.t(m[4], { ns: 'force' })
							: question.questionScore;
						return (
							<ListItem key={i}>
								<Typography>{itemTitle}</Typography>
								<ListItemText
									primary={answerResultMessage}
									primaryTypographyProps={{
										className: resultClass,
									}}
								/>
							</ListItem>
						);
					});
				})}
			</List>
		</div>
	);
};

export default TestResultSimple;



// WEBPACK FOOTER //
// ./src/components/TestResultSimple.tsx